import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './api/index.js'
// import storage from './assets/js/storage'
import Vlf from 'vlf' // localStorage
import ElementUI from 'element-ui'

// import 'element-ui/lib/theme-chalk/index.css'
import '@/theme/element.scss'

Vue.prototype.$eventBus = new Vue()
Vue.prototype.$axios = axios

Vue.use(Vlf)
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default vue



// WEBPACK FOOTER //
// ./src/main.js